import React, { useState, useEffect } from 'react';
import './Leaderboard.css';

const Leaderboard = () => {
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchLeaderboardData();
  }, []);

  const fetchLeaderboardData = async () => {
    try {
      setLoading(true);
      setError(null);

      // Replace with your actual FastAPI backend URL
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/leaderboard`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setLeaderboardData(data);
    } catch (err) {
      console.error('Error fetching leaderboard data:', err);
      setError('Failed to load leaderboard. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const getRankDisplay = (rank) => {
    if (rank === 1) return '🥇';
    if (rank === 2) return '🥈';
    if (rank === 3) return '🥉';
    return rank;
  };

  const getWinRate = (wins, totalGames) => {
    if (totalGames === 0) return '0.0';
    return ((wins / totalGames) * 100).toFixed(1);
  };

  const getDisplayName = (player) => {
    // Use name if available, otherwise fall back to email
    return player.username || player.email || 'Unknown Player';
  };

  if (loading) {
    return (
      <div className="leaderboard-container">
        <div className="leaderboard-header">
          <h1>Leaderboard</h1>
        </div>
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading leaderboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="leaderboard-container">
        <div className="leaderboard-header">
          <h1>Leaderboard</h1>
        </div>
        <div className="error-message">
          <p>{error}</p>
          <button onClick={fetchLeaderboardData} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="leaderboard-container">
      {/*<div className="leaderboard-header">*/}
      {/*  <h1>Leaderboard</h1>*/}
      {/*  <p className="leaderboard-subtitle">Top players ranked by ELO rating</p>*/}
      {/*</div>*/}

      {leaderboardData.length === 0 ? (
        <div className="empty-state">
          <p>No players found</p>
        </div>
      ) : (
        <div className="leaderboard-wrapper">
          <table className="leaderboard-table">
            <thead>
              <tr>
                <th className="rank-column">Rank</th>
                <th className="player-column">Player</th>
                <th className="elo-column">ELO</th>
                <th className="stats-column">W</th>
                <th className="stats-column">L</th>
                <th className="stats-column">D</th>
                <th className="winrate-column">Win %</th>
                <th className="games-column">Games</th>
              </tr>
            </thead>
            <tbody>
              {leaderboardData.map((player, index) => {
                const winRate = getWinRate(player.wins, player.total_games);

                return (
                  <tr key={player.id} className={`player-row ${index < 3 ? 'top-three' : ''}`}>
                    <td className="rank-cell">
                      <span className="rank-badge">{getRankDisplay(index + 1)}</span>
                    </td>
                    <td className="player-cell">
                      <div className="player-info">
                        {player.thumbnail_url && (
                          <img
                            src={player.thumbnail_url}
                            alt={getDisplayName(player)}
                            className="player-avatar"
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        )}
                        <span className="player-name">{getDisplayName(player)}</span>
                      </div>
                    </td>
                    <td className="elo-cell">
                      <span className="elo-value">{Math.round(player.current_elo)}</span>
                    </td>
                    <td className="wins-cell">{player.wins}</td>
                    <td className="losses-cell">{player.losses}</td>
                    <td className="draws-cell">{player.draws}</td>
                    <td className="winrate-cell">
                      {player.total_games > 0 ? (
                        <div className="winrate-wrapper">
                          <span className="winrate-value">{winRate}%</span>
                          <div className="winrate-bar">
                            <div
                              className="winrate-fill"
                              style={{ width: `${winRate}%` }}
                            ></div>
                          </div>
                        </div>
                      ) : (
                        <span className="no-games">-</span>
                      )}
                    </td>
                    <td className="games-cell">{player.total_games}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div className="leaderboard-footer">
        <p className="last-updated">
          Last updated: {new Date().toLocaleString()}
        </p>
        <button onClick={fetchLeaderboardData} className="refresh-button">
          ↻ Refresh
        </button>
      </div>
    </div>
  );
};

export default Leaderboard;